import { useContext, useState } from "react";
import { ChatPane } from "../components/chat";
import { Grid } from "@mui/material";
import { WizardContext } from "../components/wizard/Context";
import { useLocation } from "react-router-dom";

const Chat = ({ full = false }) => {
  const { state } = useContext(WizardContext);
  const location = useLocation();
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const { chatWindowOpen } = state;
  const isFullScreen = location.pathname === '/chat';

  const handleMouseMove = (e) => {
    if (isDragging) {
      const posX = e.clientX - offset.x;
      const posY = e.clientY - offset.y;

      if (posX <= 0 && posY <= 0) {
        setPosition({
          x: posX,
          y: posY,
        });
      }
    }
  }

  return (
    <Grid
      className="chat-window"
      sx={{
        display: (!isFullScreen && chatWindowOpen) || full ? 'block' : 'none',
        boxShadow: !isFullScreen && chatWindowOpen && '0 0 4px 0 rgba(0, 0, 0, 0.4)',
        position:  isFullScreen || full ? 'static' : 'fixed',
        right: '0',
        bottom: '0',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        transform: !isFullScreen && chatWindowOpen && `translate(${position.x}px, ${position.y}px)`,
        height: 'inherit',
      }}
      onMouseMove={handleMouseMove}
    >
      <ChatPane
        isFullScreen={isFullScreen}
        position={position}
        setOffset={setOffset}
        isDragging={isDragging}
        setIsDragging={setIsDragging}
      />
    </Grid>
  );
}

export default Chat;